import { render } from "./KeyboardEvents.vue?vue&type=template&id=3cb6575e&scoped=true&ts=true"
import script from "./KeyboardEvents.vue?vue&type=script&lang=ts"
export * from "./KeyboardEvents.vue?vue&type=script&lang=ts"

import "./KeyboardEvents.vue?vue&type=style&index=0&id=3cb6575e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb6575e"]])

export default __exports__